import axios from 'axios'
import { LocalStorageService } from '../services'

class EventBinnacleService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }
  url = process.env.REACT_APP_MIFIRMA_API
  localStorageService = new LocalStorageService()

  /**
  * @author Lucia Alvarado
  * @description Get sign request binnacle
  * @date 18-10-2022
  * @param {String} token
  * @returns {Object}
  * @memberof EventBinnacleService
  */
  async getSignRequestBinnacle(id, timezone, token) {
    let response = await axios.post(`${this.apiUrl}/sign-request-binnacle`, {
      signRequestId: id,
      timezone
    }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data.data
  }

  /**
  * @author Pedro Ramos
  * @description Get contract request and contractor binnacle
  * @date 24-02-2023
  * @param {String} timezone
  * @param {UUID} workflowExecutionId
  * @param {String} token
  * @returns {Object}
  * @memberof EventBinnacleService
  */

  async getContractAndContractorBinnacle(timezone, workflowExecutionId, token) {
    let response = await axios.get(`${this.apiUrl}/workflow-execution-log?workflowExecutionId=${workflowExecutionId}&timezone=${encodeURIComponent(timezone)}`
      , {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
    return response.data.data
  }
}

export { EventBinnacleService as default }
